import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters";

export class WorkingHour extends DataObject {
    _type = "working_hour";

    id;
    warehouse_id;
    day;
    day_label;
    start_time;
    end_time;
    checked;
    created_at;
    updated_at;
}

export class WorkingHourMapperParameter extends Parameter {
    workingHourMapper;
}

export class WorkingHourFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {WorkingHourMapperParameter} workingHourMapperParameter Parameter object containing mappers that the factory expects.
     * @param {Object, null} data Data to construct the WorkingHour object with.
     * @returns {WorkingHour}
     */
    static construct(workingHourMapperParameter, data = null) {
        if (data != null) {
            let workingHour = DataObjectFactory.getInstance().construct(
                WorkingHour,
                data ? workingHourMapperParameter.workingHourMapper(data) : null
            );
            return workingHour;
        }

        return null;
    }
}
